import {findOne} from '@/api/Api';

const fields = {
  state: {
    fields: new Map()
  },

  mutations: {
    SET_FIELDS: (state, fields) => {
      state.fields = fields
    }
  },

  actions: {
    // 调用api获取数据
    GetDictionary ({ commit }, parameter) {
      console.log(parameter,'parameter')
      return new Promise((resolve, reject) => {
          findOne('fieldFactory', parameter).then(res => {
          const result = res.dictionaries
          resolve(result)
        }).catch(error => {
          reject(error)
        })
      })
    },
    SetDictionary ({ commit }, fields) {
      console.log(fields,'fields')
      commit('SET_FIELDS', fields)
    }
  }
}

export default fields
